/**
 * Insights Highcharts.js logic.
 *
 * This file contains logic to generate the Insights Highcharts graph.
 *
 * Views: charts/medium
 */

if ($('#app-insights-chart').length) {
    var campaign_start = moment($('#campaign_start').val());
    var campaign = $('#campaign').val();
    var advertiser = $('#advertiser').val();

    /*
     * Set of colors to use for each column of the bar graph.
     */
    var vendor_colors = [
        '#023fa5', '#8e063b', '#4a6fe3', '#d33f6a', '#11c638', '#ef9708', '#0fcfc0', '#f79cd4', '#7d87b9', '#bb7784', '#8595e1', '#e07b91', '#8dd593', '#f0b98d', '#9cded6', '#f6c4e1', '#bec1d4', '#d6bcc0', '#b5bbe3', '#e6afb9', '#c6dec7', '#ead3c6', '#d5eae7', '#f3e1eb'
    ];

    /*
     * Generate patterns for the alternate columns of the bar graph.
     */
    var vendor_patterns = [];

    $.each(vendor_colors, function (index, value) {
        vendor_patterns.push({
            'id': 'custom-pattern-' + index,
            'path': {
                d: 'M 0 0 L 10 10 M 9 -1 L 11 1 M -1 9 L 1 11',
                stroke: value,
                strokeWidth: 3.5
            }
        });
    });

    /**
     * Set the Highcharts options object.
     */
    var options = {
        defs: {
            patterns: vendor_patterns
        },

        chart: {
            renderTo: 'container',
            height: '40%',
            zoomType: 'x',
            panning: true,
            panKey: 'shift',
            resetZoomButton: {
                theme: {
                    fill: '#f15925',
                    stroke: '#f15925',
                    states: {
                        hover: {
                            fill: '#41739D'
                        }
                    }
                }
            },
            alignTicks: false
        },

        legend: {
            align: "center"
        },

        credits: {
            text: '2016 - 2017 © GaleForce Digital, Inc.',
            href: 'http://www.galeforcedigital.com'
        },

        title: {
            text: 'Google Analytics vs. Ad Spend'
        },

        yAxis: [{
            title: {
                text: 'Analytics',
                style: {
                    color: "#556B2F"
                }
            },
            allowDecimals: false
        }, {
            title: {
                text: 'Ad Count',
                style: {
                    color: 'black'
                }
            },
            opposite: true,
            allowDecimals: false,
            visible: false
        }, {
            title: {
                text: 'Ad Spend',
                style: {
                    color: 'black'
                }
            },
            opposite: true,
            allowDecimals: false,
            labels: {
                formatter: function () {
                    return this.value.toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });
                }
            },
            visible: false
        }],

        xAxis: {
            type: 'string',
            crosshair: true
        },

        tooltip: {
            shared: true,
            followPointer: true,
        },

        plotOptions: {
            'line': {
                allowPointSelect: true
            },
            'column': {
                stacking: 'normal'
            }
        },
        series: [
            {
                type: 'line',
                name: 'Users',
                data: {},
                id: 'users',
                zIndex: 4,
                color: "#DC143C"
            },
            {
                type: 'line',
                name: 'Page Views',
                data: {},
                id: 'pageviews',
                zIndex: 3,
                color: "#4B0082"
            },
            {
                type: 'line',
                name: 'Sessions',
                data: {},
                id: 'sessions',
                zIndex: 2,
                color: "#006400"
            },
            {
                type: 'column',
                name: 'Ad Count',
                data: {},
                id: 'ad_count',
                zIndex: 1,
                yAxis: 1,
                color: 'black'
            },
            {
                type: 'column',
                name: 'Ad Spend',
                data: {},
                id: 'ad_cost',
                zIndex: 1,
                yAxis: 2,
                color: 'black'
            }
        ],
        exporting: {
            url: "https://18.209.154.112:7801"
        }
    };

    /**
     * Setup and initialize the date range picker for the form.
     */
    var daterange_settings_start = {
        "showWeekNumbers": true,
        "startDate": campaign_start,
        //"endDate": moment(campaign_start).add(30, 'days'),
        "maxDate": moment(),
        "autoApply": true,
        /*"dateLimit": {
            "days": 31
        },*/
        "linkedCalendars": false,
        "locale": {
            "format": "MM/DD/YYYY",
            "separator": " - ",
            "applyLabel": "Apply",
            "cancelLabel": "Cancel",
            "fromLabel": "From",
            "toLabel": "To",
            "customRangeLabel": "Custom",
            "weekLabel": "#",
            "daysOfWeek": [
                "U",
                "M",
                "T",
                "W",
                "R",
                "F",
                "S"
            ],
            "firstDay": 1
        },
        timePicker: false,
        singleDatePicker: true,
    };

    var daterange_settings_end = {
        "showWeekNumbers": true,
        //"startDate": campaign_start,
        //"endDate": moment(campaign_start).add(30, 'days'),
        "startDate": moment(campaign_start).add(30, 'days'),
        "maxDate": moment(),
        "autoApply": true,
        /*"dateLimit": {
            "days": 31
        },*/
        "linkedCalendars": false,
        "locale": {
            "format": "MM/DD/YYYY",
            "separator": " - ",
            "applyLabel": "Apply",
            "cancelLabel": "Cancel",
            "fromLabel": "From",
            "toLabel": "To",
            "customRangeLabel": "Custom",
            "weekLabel": "#",
            "daysOfWeek": [
                "U",
                "M",
                "T",
                "W",
                "R",
                "F",
                "S"
            ],
            "firstDay": 1
        },
        timePicker: false,
        singleDatePicker: true,
    };

    /**
     * Update daterange picker.
     */
    var chart_picker_update_settings = function () {
        var date_range = $('#chart_date_range_start');
        if (date_range.data('daterangepicker')) {
            date_range.data('daterangepicker').remove();
        }
        date_range.daterangepicker(daterange_settings_start);

        date_range.on('change', function () {
            checkDateRange(this)
            //chart_picker_update_date_range(this);
        })

        var date_range_end = $('#chart_date_range_end');
        if (date_range_end.data('daterangepicker')) {
            date_range_end.data('daterangepicker').remove();
        }
        date_range_end.daterangepicker(daterange_settings_end);

        date_range_end.on('change', function () {
            checkDateRange(this)
            //chart_picker_update_date_range(this);
        })
    };

    $('#chart_analytics_dimension').on('change', function () {
        chart_picker_update_date_range();
    });

    /**
     * Update dimensions when the date range changes.
     * @param select
     */
    var chart_picker_update_date_range = function (select, start = null, end = null) {
        chart_generate_loader();
        var data = {
            chart_time_period: $('[name="chart_time_period"]').val(),
            chart_date_range_start: (start === null) ? $('[name="chart_date_range_start"]').val() : start,
            chart_date_range_end: (end === null) ? $('[name="chart_date_range_end"]').val() : end,
            campaign: $('[name="campaign"]').val(),
            advertiser: $('[name="advertiser"]').val(),
            dimension: $('[name="chart_analytics_dimension"]').val()
        };

        $.ajax({
            type: 'GET',
            url: '/charts/data/medium/analytics/dimensions',
            data: data,
            dataType: 'json',
            encode: true,
            success: function (data) {
                var select = $('#chart_analytics_dimension_select');
                if ($('[name="chart_analytics_dimension"]').val() == 'page') {
                    dimension_string = 'Page';
                } else if ($('[name="chart_analytics_dimension"]').val() == 'dma') {
                    dimension_string = 'DMA';
                } else if ($('[name="chart_analytics_dimension"]').val() == 'city') {
                    dimension_string = 'City';
                }
                $('#chart_analytics_dimension_select_container').find('label').html(dimension_string);
                select.html('<option value=""></option>');

                $.each(data, function (index, value) {
                    select.append('<option value="' + value + '">' + value + '</option>')
                });

                select.data('select2').destroy();
                select.select2({
                    placeholder: "Choose zero or more",
                    closeOnSelect: false
                });

                chart_generate_loader();
            },
            error: function (xhr) {
                chart_generate_loader();
                debug(xhr.responseText);
            }
        });

        $.ajax({
            type: 'GET',
            url: '/charts/data/medium/analytics/dimensions/channels',
            data: data,
            dataType: 'json',
            encode: true,
            success: function (data) {
                var select = $('#chart_channel_dimension_select');
                // if ($('[name="chart_analytics_dimension"]').val() == 'page') {
                //     dimension_string = 'Page';
                // } else {
                //     dimension_string = 'DMA';
                // }
                // $('#chart_channel_dimension_select_container').find('label').html(dimension_string);
                select.html('<option value=""></option>');

                $.each(data, function (index, value) {
                    select.append('<option value="' + value + '">' + value + '</option>')
                });

                //select.data('select2').destroy();
                select.select2({
                    placeholder: "Choose zero or more",
                    closeOnSelect: false
                });

                //chart_generate_loader();
            },
            error: function (xhr) {
                //chart_generate_loader();
                debug(xhr.responseText);
            }
        });
    };

    /**
     * Setup the time picker and hook for changes.
     */
    $('#chart_time_period').select2({
        minimumResultsForSearch: Infinity
    }).on('change', function () {
        if ($(this).val() == 'minutely') {
            //daterange_settings_start.startDate = moment(campaign_start);
            // daterange_settings.endDate = moment(campaign_start).add(1, 'hours').minute(0).second(0);
            daterange_settings_end.startDate = moment($('[name="chart_date_range_start"]').val()).add(1, 'hours').minute(0).second(0);
            // daterange_settings.dateLimit = {
            //     "hours": 1
            // };
            daterange_settings_start.timePicker = true;
            daterange_settings_start.locale.format = 'MM/DD/YYYY h:mm A';
            daterange_settings_end.timePicker = true;
            daterange_settings_end.locale.format = 'MM/DD/YYYY h:mm A';
            //daterange_settings.timePickerIncrement = 1;
        } else if ($(this).val() == 'hourly') {
            //daterange_settings.startDate = moment(campaign_start);
            //daterange_settings.endDate = moment(campaign_start).add(23, 'hours').minute(0).second(0);
            daterange_settings_end.startDate = moment($('[name="chart_date_range_start"]').val()).add(23, 'hours').minute(0).second(0);
            // daterange_settings.dateLimit = {
            //     "hours": 24
            // };
            daterange_settings_start.timePicker = true;
            daterange_settings_start.locale.format = 'MM/DD/YYYY h:mm A';
            daterange_settings_end.timePicker = true;
            daterange_settings_end.locale.format = 'MM/DD/YYYY h:mm A';
            //daterange_settings.timePickerIncrement = 60;
        } else if ($(this).val() == 'daily') {
            //daterange_settings.startDate = moment(campaign_start);
            //daterange_settings.endDate = moment(campaign_start).add(31, 'days');
            daterange_settings_end.startDate = moment($('[name="chart_date_range_start"]').val()).add(31, 'days');
            // daterange_settings.dateLimit = {
            //     "days": 31
            // };
            daterange_settings_start.timePicker = false;
            daterange_settings_start.locale.format = "MM/DD/YYYY";
            daterange_settings_end.timePicker = false;
            daterange_settings_end.locale.format = "MM/DD/YYYY";
        } else if ($(this).val() == 'weekly') {
            //daterange_settings.startDate = moment(campaign_start);
            //daterange_settings.endDate = moment(campaign_start).add(31, 'weeks');
            daterange_settings_end.startDate = moment($('[name="chart_date_range_start"]').val()).add(31, 'weeks');
            // daterange_settings.dateLimit = {
            //     "weeks": 31
            // };
            daterange_settings_start.timePicker = false;
            daterange_settings_start.locale.format = "MM/DD/YYYY";
            daterange_settings_end.timePicker = false;
            daterange_settings_end.locale.format = "MM/DD/YYYY";
        }

        chart_picker_update_settings();
    });

    $('#chart_analytics_dimension_select').select2();

    /**
     * Generate Highchart on submit.
     */
    $('#app-chart-settings-form').on('submit', function (e) {
        e.preventDefault();
        $('.chartloader').show();
        chart_generate_loader(false);

        var data = $(this).serializeArray();
        console.log('form', $(this));

        $.ajax({
            type: 'POST',
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            url: '/charts/data/medium',
            data: data,
            dataType: 'json',
            encode: true,
            success: function (data) {
                options.series[0].data = data['users'];
                options.series[1].data = data['pageviews'];
                options.series[2].data = data['sessions'];
                x = 3;

                var color_count = 0;
                var vendor_count = 0;

                $.each(data['ad_counts'], function (index, value) {
                    options.series[x] = {
                        type: 'column',
                        name: index,
                        id: 'ad_count_' + index,
                        data: value,
                        stack: 'ad_count',
                        zIndex: 1,
                        yAxis: 1,
                        color: vendor_colors[color_count]
                    };

                    color_count++;
                    vendor_count++;
                    x++;
                });

                color_count = 0;
                $.each(data['ad_costs'], function (index, value) {
                    options.series[x] = {
                        type: 'column',
                        name: index + ' Ad Spend',
                        id: 'ad_cost_' + index,
                        data: value,
                        stack: 'ad_cost',
                        zIndex: 1,
                        yAxis: 2,
                        color: 'url(#custom-pattern-' + color_count + ')',
                        linkedTo: 'ad_count_' + index
                    };
                    x++;
                    color_count++;
                });

                options.xAxis.categories = data['dates'];
                options.tooltip.formatter = function () {
                    var s = '<b>' + this.x + '</b>';
                    var total_adcount = 0;
                    var total_adspend = 0;

                    $.each(this.points, function () {
                        if (this.series.options.id.search('ad_count') !== -1) {
                            key = this.series.options.id.replace('ad_count_', '');
                            s += '<br /><span style="font-weight: 700; color: ' + this.series.color + '">' + key + '</span>: ' + this.y + ' / '
                                + this.series.linkedSeries[0].data[this.point.index].y
                                    .toLocaleString("en-US", {
                                        style: "currency",
                                        currency: "USD",
                                        minimumFractionDigits: 2
                                    });
                            total_adcount += this.y;
                        } else if (this.series.options.id.search('ad_cost') !== -1) {
                            total_adspend += this.y;
                        } else {
                            s += '<br /><span style="font-weight: bold; color: ' + this.series.color + '">' + this.series.name + '</span>: ' + this.y.toLocaleString("en-US");
                        }
                    });

                    s += '<br /><span style="font-weight: bold; color: ' + 'black' + '">Ad Count:</span>: ' + total_adcount.toLocaleString("en-US");
                    s += '<br /><span style="font-weight: bold; color: ' + 'black' + '">Ad Spend:</span>: ' + total_adspend.toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });

                    return s;
                };

                var chart = new Highcharts.Chart(options);

                $('.highcharts-legend-item.highcharts-column-series').each(function (index, element) {
                    var legend_id = parseInt(element.className.baseVal.replace(/[^0-9]/g, ''));

                    $(element).hover(function () {
                        chart.series[(legend_id + vendor_count)].setState('hover');
                    }, function () {
                        chart.series[(legend_id + vendor_count)].setState('');
                    });
                });

                $('.vendor-buttons').html('<div class="vendor-button m-r-20 count"> <div class="vendor-button-circle" style=""></div> <div class="vendor-button-text" style=""> Ad Count</div> </div> <div class="vendor-button spend"> <div class="vendor-button-circle" style=""></div> <div class="vendor-button-text" style=""> Ad Spend</div> </div>');

                $('.chartloader').hide();
                chart_generate_loader(false);
            },
            error: function (xhr) {
                console.log(xhr)
                if (xhr.status === 409) {
                    global_notification('warning', 'You can\'t use Time Period By Minute option in a Google Analytics Report type GA4.', 15000)
                } else {
                    debug(xhr.responseText);
                }
                $('.chartloader').hide();
                chart_generate_loader(false);
            }
        });
    });

    /**
     * Ready function. Initialize inputs and values.
     */
    $(document).ready(function () {
        var invoice_select = $('#chart_invoice_ids');
        var vendor_select = $('#chart_invoice_vendors');

        $.ajax({
            type: 'GET',
            url: '/advertisers/' + advertiser + '/campaigns/' + campaign + '/invoices',
            dataType: 'json',
            encode: true,
            success: function (data) {
                console.log('alldata', data);
                $.each(data['invoices'], function (index, value) {
                    invoice_select.append('<option value="imp_' + value['id'] + '" selected>' + value['name'] + " (Imported)</option>");
                });
                $.each(data['manual_invoices'], function (index, value) {
                    invoice_select.append('<option value="man_' + value['id'] + '" selected>' + value['name'] + " (Manual)</option>");
                });
                $.each(data['stations'], function (index, value) {
                    vendor_select.append('<option value="' + value['id'] + '" selected>' + value['call_letters'] + "</option>");
                });
                invoice_select.multiSelect({
                    selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
                    selectionHeader: "<div style='height: 38px;'><label>Selected</label></div>",
                    afterInit: function(ms){
                        var that = this,
                            $selectableSearch = that.$selectableUl.prev(),
                            selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

                        that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                            .on('keydown', function(e){
                                if (e.which === 40){
                                    that.$selectableUl.focus();
                                    return false;
                                }
                            });
                    },
                    afterSelect: function(values){
                        this.qs1.cache();
                    },
                    afterDeselect: function(values){
                        this.qs1.cache();
                    }
                });

                vendor_select.multiSelect({
                    selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
                    selectionHeader: "<div style='height: 38px;'><label>Selected</label></div>",
                    afterInit: function(ms){
                        var that = this,
                            $selectableSearch = that.$selectableUl.prev(),
                            selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

                        that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                            .on('keydown', function(e){
                                if (e.which === 40){
                                    that.$selectableUl.focus();
                                    return false;
                                }
                            });
                    },
                    afterSelect: function(values){
                        this.qs1.cache();
                    },
                    afterDeselect: function(values){
                        this.qs1.cache();
                    }
                });
            },
            error: function (xhr) {

            }
        });

        chart_picker_update_date_range($('#chart_date_range'));


    });

    /**
     * Show/Hide the loader overlay.
     * @param disabled
     */
    var chart_generate_loader = function (disabled) {
        if (typeof disabled === 'undefined') {
            disabled = true;
        }
        button = $('#generate_chart');
        if (button.hasClass('disabled')) {
            button.removeClass('disabled').attr('disabled', null).html('Generate Chart');
            if (disabled) {
                $('#app-chart-settings-form').find('select').prop("disabled", false);
                $('#app-chart-settings-form').find('input').prop("disabled", false);
                $('#chart_invoice_ids').multiSelect('refresh');
                $('#chart_invoice_vendors').multiSelect('refresh');
            }
        } else {
            button.addClass('disabled').attr('disabled', 'disabled').html('<i class="fa fa-circle-o-notch fa-spin"></i>');
            if (disabled) {
                $('#app-chart-settings-form').find('select').prop("disabled", true);
                $('#app-chart-settings-form').find('input').prop("disabled", true);
                $('#chart_invoice_ids').multiSelect('refresh');
                $('#chart_invoice_vendors').multiSelect('refresh');
            }
        }
    };

    var changedAlready = false;
    /**
     * Checks that the Date Range is correct when changing any of the dates
     */
    var checkDateRange = function(dateInput){
        if(changedAlready) {
            changedAlready = false;
            return;
        }else
            changedAlready = true;
        var inputId = $(dateInput).attr("id")
        var toUpdate = $("#chart_date_range_end")
        var timePeriod = $('[name="chart_time_period"]').val()
        var addOrSubs = "add";
        var newVal = $("#chart_date_range_end").val()
        if(inputId == "chart_date_range_end"){
            toUpdate = $("#chart_date_range_start")
            addOrSubs = "subtract";
            newVal = $("#chart_date_range_start").val()
        }
        switch (timePeriod) {
            case "minutely":
                if(moment($("#chart_date_range_end").val(), "MM/DD/YYYY h:mm A").subtract(1, "hours") > moment($("#chart_date_range_start").val(), "MM/DD/YYYY h:mm A") || moment($("#chart_date_range_end").val(), "MM/DD/YYYY h:mm A") < moment($("#chart_date_range_start").val(), "MM/DD/YYYY h:mm A")){
                    newVal = moment($(dateInput).val())[addOrSubs](1, "hours").format("MM/DD/YYYY h:mm A")
                    toUpdate.val(newVal).trigger("change")
                }else
                    newVal = moment(newVal, "MM/DD/YYYY h:mm A").format("MM/DD/YYYY h:mm A")
                break;
            case "hourly":
                if(moment($("#chart_date_range_end").val(), "MM/DD/YYYY h:mm A").subtract(23, "hours") > moment($("#chart_date_range_start").val(), "MM/DD/YYYY h:mm A") || moment($("#chart_date_range_end").val(), "MM/DD/YYYY h:mm A") < moment($("#chart_date_range_start").val(), "MM/DD/YYYY h:mm A")){
                    newVal = moment($(dateInput).val())[addOrSubs](23, "hours").format("MM/DD/YYYY h:mm A")
                    toUpdate.val(newVal).trigger("change")
                }else
                    newVal = moment(newVal, "MM/DD/YYYY h:mm A").format("MM/DD/YYYY h:mm A")
                break;
            case "daily":
                if(moment($("#chart_date_range_end").val(), "MM/DD/YYYY").subtract(31, 'days') > moment($("#chart_date_range_start").val(), "MM/DD/YYYY") || moment($("#chart_date_range_end").val(), "MM/DD/YYYY h:mm A") < moment($("#chart_date_range_start").val(), "MM/DD/YYYY h:mm A")){
                    newVal = moment($(dateInput).val())[addOrSubs](31, 'days').format("MM/DD/YYYY")
                    toUpdate.val(newVal).trigger("change")
                }
                else
                    newVal = moment(newVal, "MM/DD/YYYY").format("MM/DD/YYYY")
                break;
            case "weekly":
                if(moment($("#chart_date_range_end").val(), "MM/DD/YYYY").subtract(31, 'weeks') > moment($("#chart_date_range_start").val(), "MM/DD/YYYY") || moment($("#chart_date_range_end").val(), "MM/DD/YYYY h:mm A") < moment($("#chart_date_range_start").val(), "MM/DD/YYYY h:mm A")){
                    newVal = moment($(dateInput).val())[addOrSubs](31, 'weeks').format("MM/DD/YYYY")
                    toUpdate.val(newVal).trigger("change")
                }else
                    newVal = moment(newVal, "MM/DD/YYYY").format("MM/DD/YYYY")
                break;
            default:
                break;
        }

        chart_picker_update_date_range(dateInput, (inputId == "chart_date_range_start") ? $("#chart_date_range_start").val() : newVal, (inputId == "chart_date_range_end") ? $("#chart_date_range_end").val() : newVal);
        return;
    }


    chart_picker_update_settings();
}
